import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Flex } from 'rebass';
import { change, formValueSelector, reduxForm } from 'redux-form';
import styled from 'styled-components';
import Link from '../../../components/Link';
import { Whitespace } from '../../../components_new/common';
import Ratings from '../../../components_new/common/Ratings';
import Text from '../../../components_new/common/Text';
import { Separator } from '../../../components_new/Separator';
import { colors } from '../../../tailwind';
import Button from './../../../components_new/common/FormComponents/Button';
import DateRange from './../../../components_new/common/FormComponents/DateRange/DateRange';
import appleBadge from './appleBadge.png';

const Heart = styled.div`
  background: url('/icons/blue.svg') no-repeat center;
  background-size: cover;
  height: 32px;
  width: 32px;
  cursor: pointer;
`;

const ComingSoon = styled(Text)`
  white-space: pre-wrap;
`;

class Request extends Component {
  constructor() {
    super();
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
    };
  }

  handleSubmit() {}

  renderHostView() {
    const { handleSubmit, preview, startDate, endDate, blockedDates, listId } = this.props;
    return (
      <div>
        <Box>
          <Flex justifyContent="space-between">
            <Box>
              <Text textheader primary inline>
                ${this.props.price}&nbsp;
              </Text>
              <Text small primary inline>
                per day
              </Text>
              {this.props.averageRating ? (
                <Flex mt={1}>
                  <Ratings small2 rating={this.props.averageRating} />
                  <Text small gray ml={2}>
                    {this.props.reviewsCount}
                  </Text>
                </Flex>
              ) : (
                <Flex>
                  <Text small>There are no reviews for this item.</Text>
                </Flex>
              )}
            </Box>
          </Flex>
        </Box>
        <Link to={'/add-listing/' + listId + '/review'}>
          <Box mt={4}>
            <Button
              muted={preview}
              primary={!preview}
              action
              disabled={preview}
              style={{
                width: '100%',
                borderColor: colors.secondary,
                color: preview && colors.secondary,
              }}
              height="36px"
              type={'normal'}
            >
              Edit Listing
            </Button>
          </Box>
        </Link>
      </div>
    );
  }

  changeDayCount = (e) => {
    const { change, startDate } = this.props;
    const newDayCount = e.target.value;
    if (newDayCount < 1) {
      return;
    }
    const newEndDate = moment(startDate).add(newDayCount - 1, 'days');
    change('endDate', newEndDate);
    change('units', newDayCount);
  };

  renderGuestView() {
    const {
      handleSubmit,
      preview,
      startDate,
      endDate,
      blockedDates,
      units,
      contact,
      price,
    } = this.props;
    return (
      <div>
        <Box>
          <Flex justifyContent="space-between">
            <Box>
              <Text header inline primary>
                ${price}&nbsp;
              </Text>
              <Text inline primary>
                per day
              </Text>
              {this.props.averageRating ? (
                <Flex mt={1}>
                  <Ratings small2 rating={this.props.averageRating} />
                  <Text small gray ml={2}>
                    {this.props.reviewsCount}
                  </Text>
                </Flex>
              ) : (
                <Flex>
                  <Text small>There are no reviews for this item.</Text>
                </Flex>
              )}
            </Box>
            <Flex flexDirection="column" alignItems="center">
              {
                //   <Heart
                //   onClick={
                //     !preview
                //       ? () =>
                //           alert(
                //             'Thanks for testing our demo! This feature is coming soon!',
                //           )
                //       : null
                //   }
                // />
              }
            </Flex>
          </Flex>
        </Box>
        <Whitespace smaller />
        <Separator />
        {/* UNTIL "REQUEST ON WEB" IS IMPLEMENTED DISPLAY THIS INSTEAD */}
        {/* <Box>
          <Text primary>See the calendar for availability {'>'}</Text>
          <DateRange
            listId={this.props.id || 16}
            minimumNights={this.props.minimumNights || 0}
            maximumNights={this.props.maximumNights || 30}
            blockedDates={blockedDates || []}
            maxDaysNotice={this.props.maxDaysNotice || 180}
            formName="RequestForm"
            disabled={preview}
            change={
              this.props.change ||
              ((formName, fieldName, value) => {
                console.log(formName, fieldName, value);
              })
            }
            checkAvailability={this.props.checkAvailability || (() => true)}
            showClearDates={false}
            initialStartDate={startDate}
            initialEndDate={endDate}
          />
        </Box> */}
        <Whitespace medium />
        <ComingSoon>
          Web reservations coming soon! To make a reservation, please download the app.
        </ComingSoon>
        <Whitespace medium />
        <div>
          <Flex flexDirection="row" alignItems="center">
            <Box border p={1} width={1 / 2}>
              <a href="https://apps.apple.com/us/app/yoodlize/id1448525055">
                <img
                  style={{ width: '100%', height: '38px', objectFit: 'contain' }}
                  src={appleBadge}
                  alt="Download on the App Store"
                />
              </a>
            </Box>
            {/* <img src={googleBadge} alt="Download the Yoodlize app from the Google Play Store" /> */}
            <Box border p={1} width={1 / 2}>
              <a href="https://play.google.com/store/apps/details?id=com.yoodlize&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  style={{ width: '100%', height: '56px', objectFit: 'contain' }}
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                />
              </a>
            </Box>
          </Flex>
        </div>

        {/* "REQUEST ON WEB" COMING SOON - DON'T REMOVE THIS CODE */}
        {/* <Text h6 grayDarkMedium textAlign="center">
          Reserve this item
        </Text>
        <form id="RequestForm" onSubmit={handleSubmit}>
          <Box mt={3} mb={2} className="g g-g-s g-tc-fr-2">
            <Box
              style={{
                display: 'inline-block',
                width: '146px',
              }}
            >
              <Text label>Start day</Text>
            </Box>
            <Box
              style={{
                display: 'inline-block',
              }}
            >
              <Text label>Duration</Text>
            </Box>
            <DateRange
              listId={this.props.id || 16}
              minimumNights={this.props.minimumNights || 0}
              maximumNights={this.props.maximumNights || 30}
              blockedDates={blockedDates || []}
              maxDaysNotice={this.props.maxDaysNotice || 180}
              formName="RequestForm"
              disabled={preview}
              change={
                this.props.change ||
                ((formName, fieldName, value) => {
                  console.log(formName, fieldName, value);
                })
              }
              checkAvailability={this.props.checkAvailability || (() => true)}
              showClearDates={false}
              initialStartDate={startDate}
              initialEndDate={endDate}
            />
            <div className="f f-columns f-start-center">
              <div className="w-60">
                <InputStyle
                  type="number"
                  placeholder="1"
                  min="1"
                  max="90"
                  style={{ height: 43 }}
                  onChange={this.changeDayCount}
                />
              </div>
              <Text large ml={3}>
                day(s)
              </Text>
            </div>
          </Box>
          <Whitespace smaller />
          <div className="g g-tc-1a1 f-ji-center">
            <div>
              <Text primary>
                {(startDate && startDate.calendar().split(' ')[0]) || 'Select start'}
              </Text>
            </div>
            <div>
              <i className="fal fa-chevron-right" />
            </div>
            <div>
              <Text primary>
                {(endDate && endDate.calendar().split(' ')[0]) || (startDate && 'Select duration')}
              </Text>
            </div>
          </div>
          <Whitespace smaller />
          {endDate && units && (
            <div>
              <Text noclip mt={4}>
                You will coordinate your pickup and drop off times with the owner before your
                reservation is approved. At their discretion they may allow for pickup or return
                outside of the days you've selected above.
              </Text>
              <Whitespace smaller />
            </div>
          )}
          <Box mt={4}>
            <Button
              muted={preview}
              primary={!preview}
              action
              disabled={!startDate || !endDate}
              style={{
                width: '100%',
                borderColor: colors.secondary,
                color: preview && colors.secondary,
              }}
              height="36px"
              type={preview ? 'normal' : 'submit'}
            >
              Start Request
            </Button>
          </Box>
        </form> */}
      </div>
    );
  }

  render() {
    const { isHost, preview } = this.props;

    if (isHost && !preview) {
      return this.renderHostView();
    }
    return this.renderGuestView();
  }
}

Request = reduxForm({
  form: 'RequestForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Request);

const selector = formValueSelector('RequestForm'); // <-- same as form name

const mapState = (state) => ({
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  units: selector(state, 'units'),
});

export default connect(mapState, { change })(Request);

/*
listId
hostId
guestId - optional
checkIn
checkOut
basePrice
currency - hard code to USD
total
createdAt
updatedAt
*/



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/Request.js